
import { marked } from 'marked';

/**
 * Удаляет форматирование Markdown в стиле Telegram (MarkdownV2), оставляя чистый текст.
 */
export const stripMarkdown = (text: any): string => {
    if (typeof text !== 'string' || !text) return "";
    return text
        // 1. Remove Headers
        .replace(/^#+\s+/gm, '')
        // 2. Unescape Markdown escapes (e.g., \* -> *)
        .replace(/\\([*_{}[\]()#+\-.!|])/g, '$1')
        // 3. Bold: *text*
        .replace(/\*([^*]+)\*/g, '$1')
        // 4. Italic: _text_
        .replace(/_([^_]+)_/g, '$1')
        // 5. Strikethrough: ~text~
        .replace(/~([^~]+)~/g, '$1')
        // 6. Spoiler ||text||
        .replace(/\|\|(.*?)\|\|/g, '$1')
        // 7. Code
        .replace(/`([^`]+)`/g, '$1')
        .replace(/```([\s\S]*?)```/g, '$1')
        // 8. Links: [text](url) -> text (url) if url is informative, otherwise just text
        // For plain text networks, it's often better to show the URL.
        .replace(/\[(.*?)\]\((.*?)\)/g, (match, text, url) => {
            if (text === url) return url;
            return `${text} (${url})`;
        })
        .trim();
};

/**
 * Парсер для конвертации Telegram Markdown (V2) в HTML для превью.
 */
export const parseMarkdownToHtml = (content: any) => {
    if (typeof content !== 'string' || !content) return { __html: "" };

    let adaptedContent = content;

    // 1. Спойлеры: ||текст||
    adaptedContent = adaptedContent.replace(
        /\|\|(.*?)\|\|/g, 
        '<span class="tg-spoiler" style="background-color: #333; color: transparent; cursor: pointer;" onclick="this.style.color=\'inherit\'" title="Click to reveal">$1</span>'
    );

    // 2. Telegram Bold: *текст* -> <b>текст</b>
    adaptedContent = adaptedContent.replace(/\*([^*]+)\*/g, '<b>$1</b>');

    // 3. Telegram Strikethrough: ~текст~ -> <s>текст</s>
    adaptedContent = adaptedContent.replace(/~([^~]+)~/g, '<s>$1</s>');

    // 4. Telegram Italic: _текст_ (Marked понимает это нативно)
    
    // ЭТАП 2: Рендеринг через marked
    let html = marked.parse(adaptedContent, { 
        async: false,
        breaks: true, // Telegram переносит строку по Enter
        gfm: true 
    }) as string;
    
    return { __html: html };
};

/**
 * Хелперы для вставки
 */
export const toggleMarkdownFormatting = (
    input: HTMLTextAreaElement,
    syntax: string, 
    blockMode: boolean = false
) => {
    const start = input.selectionStart;
    const end = input.selectionEnd;
    const originalText = input.value;
    const selectedText = originalText.substring(start, end);
    const syntaxLen = syntax.length;

    let newText = "";
    let newSelectionStart = start;
    let newSelectionEnd = end;

    const before = originalText.substring(start - syntaxLen, start);
    const after = originalText.substring(end, end + syntaxLen);
    
    const isWrapped = before === syntax && after === syntax;

    if (isWrapped && !blockMode) {
        newText = originalText.substring(0, start - syntaxLen) + 
                  selectedText + 
                  originalText.substring(end + syntaxLen);
        newSelectionStart = start - syntaxLen;
        newSelectionEnd = end - syntaxLen;
    } else {
        if (blockMode) {
            const isStartOfLine = start === 0 || originalText[start - 1] === '\n';
            const prefix = isStartOfLine ? '' : '\n';
            newText = originalText.substring(0, start) + 
                      prefix + syntax + "\n" + selectedText + "\n" + syntax + 
                      originalText.substring(end);
            newSelectionStart = start + prefix.length + syntax.length + 1;
            newSelectionEnd = newSelectionStart + selectedText.length;
        } else {
            newText = originalText.substring(0, start) + 
                      syntax + selectedText + syntax + 
                      originalText.substring(end);
            newSelectionStart = start + syntaxLen;
            newSelectionEnd = end + syntaxLen;
        }
    }

    return { newText, newSelectionStart, newSelectionEnd };
};

export const insertAtCursor = (input: HTMLTextAreaElement, textToInsert: string) => {
    const start = input.selectionStart;
    const end = input.selectionEnd;
    const originalText = input.value;
    
    const newText = originalText.substring(0, start) + textToInsert + originalText.substring(end);
    const newCursor = start + textToInsert.length;
    
    return { newText, newCursor };
};
